<template>
    <div class="margin-header">
        <TopBar :title="$vuetify.lang.t('$vuetify.HistoryQuota.pageName')" />
        <div class="box-round display-height">
            <div class="box-content pt-0 px-0">
                <HeaderHistory active="quota"/>
                <div class="px-7 py-5 line-liff-detail">
                    {{$vuetify.lang.t('$vuetify.HistoryQuota.year')}} {{ year }}
                </div>
                <div class="d-flex flex-nowrap header-item line-liff-detail">
                    <v-col cols="8" class="px-0 py-2  pl-7">
                        {{$vuetify.lang.t('$vuetify.HistoryQuota.header.type')}}
                    </v-col>
                    <v-col cols="4" class="px-0 py-2 text-right pr-7">
                        {{$vuetify.lang.t('$vuetify.HistoryQuota.header.quota')}}
                    </v-col>
                </div>
                <div class="font-roboto">
                    <div class="d-flex flex-nowrap list-item" v-for="(v,i) of list" :key="i">
                        <v-col cols="8" class="px-0 py-2 pl-7 text-truncate">
                            <div class="mb-1 d-flex align-center">
                                {{v.type}}
                            </div>
                        </v-col>
                        <v-col cols="4" class="px-0 py-2 pr-7 text-right">{{v.quota}}</v-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import HeaderHistory from './../components/HeaderHistory.vue'
import TopBar from '@/components/Liff/Components/header/TopBar.vue'

export default {
    name: 'HistoryQuota',
    components: {
        TopBar,
        HeaderHistory
    },
    data: function () {
        return {
            lineUserId: null,
            lineLiffId: process.env.VUE_APP_LINE_LIFF_HISTORY_QUOTA,
            title: null,
            date: null,
            list: [],
            year: new Date().getFullYear() + 543
        }
    },
    created: function () {
        this.title = 'History'
        this.date = moment().format('YYYY-MM-DD')
    },
    mounted: function () {
        this.initialData()
    },
    methods: {
        initialData: async function () {
            this.$store.dispatch('setLoading', true)
            try {
                const lineUserId = await this.$liffUtil.getLineIdForLiff(this.lineLiffId)
                this.lineUserId = lineUserId
                const params = {
                    lineId: this.lineUserId,
                    date: this.date
                }
                const res = await this.axios.post('quotas/individual/line', params)
                if (res && res.data && res.data.status === 'ok') {
                    this.list = res.data.data
                }
            } catch {
                // do something with error
            }
            this.$store.dispatch('setLoading', false)
        }
    }
}
</script>

<style lang="scss" scoped>
  @import '@/styles/color.scss';
  .header-item {
      margin-top: -5px;
      color: $base-grey2;
      background: #d9e4ed;
      font-size: 14px;
  }
  .list-item {
      padding: 0px 0;
      &:not(:last-child){
          border-bottom: 1px solid $base-grey4;
      }
  }
</style>
